import React from 'react';
import {Mode} from '../Helper/constants';
import ABDMEnrollemtStepBase from './EnrollmentStepBase'

export default class ABDMAdhaarEnrollment extends ABDMEnrollemtStepBase {

    consent_texts = {
        'ENGLISH': "I am voluntarily sharing my Aadhaar Number / Virtual ID issued by the Unique Identification Authority of India (\"UIDAI\"), and my demographic information for the purpose of creating an Ayushman Bharat Health Account number (\"ABHA number\") and Ayushman Bharat Health Account address (\"ABHA Address\"). I authorize NHA to use my Aadhaar number / Virtual ID for performing Aadhaar based authentication with UIDAI as per the provisions of the Aadhaar (Targeted Delivery of Financial and other Subsidies, Benefits and Services) Act, 2016 for the aforesaid purpose. I understand that UIDAI will share my e-KYC details, or response of \"Yes\" with NHA upon successful authentication.",
        'HINDI': "मैं स्वेच्छा से अपना आधार नंबर/वर्चुअल आईडी जिसे भारतीय विशिष्ट पहचान प्राधिकरण (\"UIDAI\") द्वारा जारी किया गया है, और आयुष्मान भारत स्वास्थ्य खाता संख्या (\"ABHA नंबर\") और आयुष्मान भारत स्वास्थ्य खाता पता (\"ABHA पता\") बनाने के उद्देश्य से अपनी जनसांख्यिकीय जानकारी साझा कर रहा हूँ। मैं NHA को उपरोक्त उद्देश्य के लिए आधार (वित्तीय और अन्य सब्सिडी, लाभ और सेवाओं का लक्षित वितरण) अधिनियम, 2016 के प्रावधानों के अनुसार UIDAI के साथ आधार आधारित प्रमाणीकरण करने के लिए मेरे आधार नंबर/वर्चुअल आईडी का उपयोग करने के लिए अधिकृत करता हूँ। मैं समझता हूँ कि UIDAI सफल प्रमाणीकरण पर मेरे ई-केवाईसी विवरण, या \"हाँ\" का जवाब NHA के साथ साझा करेगा।",
        'KANNADA': "ನಾನು ಸ್ವಯಂಪ್ರೇರಿತವಾಗಿ ನನ್ನ ಆಧಾರ್ ಸಂಖ್ಯೆ/ವರ್ಚುಯಲ್ ಐಡಿ ಅನ್ನು ಭಾರತೀಯ ವಿಶಿಷ್ಟ ಗುರುತಿನ ಪ್ರಾಧಿಕಾರ (\"UIDAI\") ನೀಡಿರುವ ಮತ್ತು ನನ್ನ ಜನಸಂಖ್ಯಾ ಮಾಹಿತಿಯನ್ನು ಆಯುಷ್ಮಾನ್ ಭಾರತ ಆರೋಗ್ಯ ಖಾತೆ ಸಂಖ್ಯೆ (\"ABHA ಸಂಖ್ಯೆ\") ಮತ್ತು ಆಯುಷ್ಮಾನ್ ಭಾರತ ಆರೋಗ್ಯ ಖಾತೆ ವಿಳಾಸ (\"ABHA ವಿಳಾಸ\") ರಚಿಸುವ ಉದ್ದೇಶಕ್ಕಾಗಿ ಹಂಚಿಕೊಳ್ಳುತ್ತಿದ್ದೇನೆ. ನಾನು NHA ಗೆ ನನ್ನ ಆಧಾರ್ ಸಂಖ್ಯೆ/ವರ್ಚುಯಲ್ ಐಡಿಯನ್ನು UIDAI ಜೊತೆ ಆಧಾರ್ ಆಧಾರಿತ ಪ್ರಮಾಣೀಕರಣ ನಡೆಸಲು ಅನುಮತಿಸುತ್ತೇನೆ, ಇದು ಆಧಾರ್ (ಆರ್ಥಿಕ ಮತ್ತು ಇತರ ಸಹಾಯಧನಗಳು, ಪ್ರಯೋಜನಗಳು ಮತ್ತು ಸೇವೆಗಳ ಗುರಿ ವಿತರಣಾ) ಕಾಯ್ದೆ, 2016 ರ ನಿಯಮಾವಳಿಗಳಿಗೆ ಅನುಗುಣವಾಗಿದೆ. UIDAI ನನ್ನ e-KYC ವಿವರಗಳನ್ನು ಅಥವಾ ಯಶಸ್ವಿ ಪ್ರಮಾಣೀಕರಣದ ನಂತರ \"ಹೌದು\" ಎಂಬ ಪ್ರತಿಕ್ರಿಯೆಯನ್ನು NHA ಗೆ ಹಂಚಿಕೊಳ್ಳುವುದು ಎಂದು ನಾನು ಅರ್ಥಮಾಡಿಕೊಂಡಿದ್ದೇನೆ."
    }

    state = {
        data : {
            document_id: '',
            language: 'ENGLISH',
            consent: '',
            otp_mode: 'AADHAAR'
        },
        error_message: '',
        errors: {},
        consent_text: this.consent_texts['ENGLISH']
    }

    constructor(props) {
        super(props);
        this.syncMessage();
    }

    syncMessage = () => {
        this.state = {
            ...this.state,
            message: this.props.message[this.getComponentStep()] || "",
            error_message: this.props.error_message[this.getComponentStep()] || "",
        };
        if(this.state.error_message == "Invalid aadhaar card number") {
            this.state.errors.document_id = this.state.error_message;
            this.state.error_message = ""
        }
    }

    validateInput = () => {
        this.state.errors.document_id = this.state.data.document_id.length !== 12 ? 'Please enter your 12 digit aadhaar number' : '';
        this.state.errors.language = this.state.data.language.length === 0 ? 'Please select a language' : '';
        this.state.errors.consent = (this.state.data.consent.length === 0 || this.state.data.consent === false) ? 'Please provide your consent' : '';
    }

    handleResponse = (response) => {
        if(response.status === 200) {
            this.props.updateReqId(response.req_id);
            this.props.updateStep(2, response.message, '', this.state.data);
        } else if(response.status === 500) {
            this.props.updateStep(1, '', response.message);
        }
    }

    getEndpointUrl = () => {
        let url = '/dashboard/abdm/enroll/request_otp'
        if(Mode.DEBUG) {
            url = Mode.TEST_HOST + url;
        }
        return url;
    }

    getRequestData = () => {
        return this.state.data
    }

    getComponentStep = () => {
        return 1
    }

    updateContentText = (language) => {
        this.state.consent_text = this.consent_texts[language];
    }

    handleChange = (e) => {
        const target = e.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let name = target.name;
        if(name == "language") {
            this.updateContentText(value);
        }
        this.setState({
            data:{
                ...this.state.data,
                [name]: value
            }
        });
    }

    render_internal = () => {
        return (
            <>
                <h1 className='mb-4'>Using Aadhaar Number</h1>

                {(this.state.error_message.length > 0)?
                <div className='alert alert-danger mb-3'>
                    {this.state.error_message}
                </div>
                :null}

                <div className="form-group mb-3">

                    <label className="control-label required ds_form_labels" htmlFor="Language">Aadhaar Number</label>
                    <input id="document_id" name="document_id" type="number" placeholder="Enter your Aadhaar Number" className="form-control mt-0" onChange={this.handleChange} />
                    <p className='error_msg'>{this.state.errors.document_id}</p>
                </div>

                <div className="form-group mb-4">
                    <label className="control-label required ds_form_labels" htmlFor="Language">Select language</label>
                    <select id="language" name="language" placeholder="Language" type="text" className="form-select mt-0" onChange={this.handleChange}>
                        <option value="ENGLISH">English</option>
                        <option value="HINDI">Hindi</option>
                        <option value="KANNADA">Kannada</option>
                    </select>
                    <p className='error_msg'>{this.state.errors.language}</p>
                </div>
                    
                <div className="form-group mb-3">
                    <div style={{background:"#f9f9f9",border:"1px solid #ddd",textAlign:"left",fontSize:"12px","padding":"10px",lineHeight:"18px"}}>
                        { this.state.consent_text }
                    </div>
                </div>

                <div className="form-check mb-4">
                    <input className="form-check-input" type="checkbox" id='consent' name="consent" onChange={this.handleChange} style={{ marginTop: '7px'}} />
                    <p style={{ textAlign: 'left', paddingTop: '5px', fontSize: 'small', marginBottom: '15px', marginTop: '20px' }}>I agree to the terms and conditions. </p>
                    <p className='error_msg'>{this.state.errors.consent}</p>
                </div>

                <button className="btn btn-primary btn-block w-100" onClick={this.submitRequest}>Create ABHA Card</button>
            </>
        )
    }
}